import { render } from "./TransactionAttempt.vue?vue&type=template&id=ecdc4f92"
import script from "./TransactionAttempt.vue?vue&type=script&lang=js"
export * from "./TransactionAttempt.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__